import { render } from "./MultiplePhotoButtonComponent.vue?vue&type=template&id=08867cd7&ts=true"
import script from "./MultiplePhotoButtonComponent.vue?vue&type=script&lang=ts"
export * from "./MultiplePhotoButtonComponent.vue?vue&type=script&lang=ts"

import "./MultiplePhotoButtonComponent.vue?vue&type=style&index=0&id=08867cd7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__